import { Action } from "@ngrx/store";

import {
  CouponCodeFailError,
  GenericError,
  PaymentMode,
  PlutosRequest,
  Product,
  SaleItem,
  SaleOrder
} from "@tendercuts/models";
import { EdcMachine } from "@tendercuts/models/store/edc-machine";
import { AppState } from "../state";
import { PosQuote, PosUser, ValidateCouponCode } from '../../models';

export class ActionCartAddProduct implements Action {
  readonly type = "ACTION_CART_ADD_PRODUCT";

  constructor(public product: Product, public weight: number) {}
}

export class ActionUpdateQuoteSuccess implements Action {
  readonly type = "ACTION_UPDATE_QUOTE_SUCCESS";

  constructor(public quote: PosQuote) {}
}
//action is used to set the barcode in quote
export class ActionCartAddBarcode implements Action {
  readonly type = "ACTION_CART_ADD_BARCODE";

  constructor(public barcode: string) {}
}

export class ActionCartCreate implements Action {
  readonly type = "ACTION_CART_CREATE";

  constructor(public payload: PosUser) {}
}

export class ActionCartTenderCash implements Action {
  readonly type = "ACTION_CART_TENDER_CASH";

  constructor(public tenderCash: number, public changeCash: number) {}
}

export class ActionAddUser implements Action {
  readonly type = "ACTION_ADD_USER";

  constructor(public user: PosUser) {}
}

export class ActionCartCardDetail implements Action {
  readonly type = "ACTION_CART_CARD_DETAIL";

  constructor(public transactionId: string, public cardNumber: string) {}
}

export class ActionCartRemoveProduct implements Action {
  readonly type = "ACTION_CART_REMOVE_PRODUCT";

  constructor(public payload: Product) {}
}

export class ActionCartLoadFailed implements Action {
  readonly type = "ACTION_CART_LOAD_FAILED";

  constructor(public payload: GenericError | CouponCodeFailError) {}
}

export class ActionCartSelectPaymentMode implements Action {
  readonly type = "ACTION_CART_SELECT_PAYMENT";

  constructor(public payload: PaymentMode) {}
}

export class ActionQuoteApplyReward implements Action {
  readonly type = "ACTION_QUOTE_APPLY_REWARD";

  constructor(public rewardPoints: number) {}
}
export class ActionQuoteRemoveReward implements Action {
  readonly type = "ACTION_QUOTE_REMOVE_REWARD";
  constructor() {}
}
export class ActionQuoteSetPayment implements Action {
  readonly type = "ACTION_QUOTE_SET_PAYMENT";
  constructor(public paymentMode: string) {}
}

export class ActionQuoteFromLocal implements Action {
  readonly type = "ACTION_QUOTE_FROM_LOCAL";
  constructor(public quote: PosQuote) {}
}

export class ActionQuoteClearPayment implements Action {
  readonly type = "ACTION_QUOTE_CLEAR_PAYMENT";
  constructor() {}
}

export class ActionQuoteApplyCoupon implements Action {
  readonly type = "ACTION_QUOTE_APPLY_COUPON";
  constructor(
    public payload: {
      couponCode: string;
      appState: AppState;
    }
  ) {}
}

/**
 * if coupon applied successfully return response, couponcode.
 */
export class ActionQuoteCouponApplied implements Action {
  readonly type = "ACTION_QUOTE_COUPON_APPLIED";
  constructor(public validateCouponCode: ValidateCouponCode, public couponCode: string) {}
}

export class ActionInvalidCouponApplied implements Action {
  readonly type = "ACTION_INVALID_COUPON_APPLIED";
  constructor() {}
}

export class ActionRemoveDiscount implements Action {
  readonly type = "ACTION_REMOVE_COUPON_APPLIED";
  constructor() {}
}
export class ActionClearCart implements Action {
  readonly type = "ACTION_CLEAR_CART";
  constructor() {}
}

export class ActionClearLocalCart implements Action {
  readonly type = "ACTION_CLEAR_LOCAL_CART";
  constructor() {}
}

export class ActionOrderPlaced implements Action {
  readonly type = "ACTION_ORDER_PLACED";
  constructor() {}
}

/**when combo order placed successfully 
 * dispatch this action and set the sale order to the redux
 */
export class ActionInstantSyncOrderSuccess implements Action {
  readonly type = "ACTION_COMBO_ORDER_PLACED";
  constructor(public saleOrder: SaleOrder) {}
}

export class ActionQuoteSetOrderId implements Action {
  readonly type = "ACTION_QUOTE_SET_ORDERID";
  constructor(public orderId: string) {}
}

export class ActionCreateOrder implements Action {
  readonly type = "ACTION_CREATE_ORDER";
  constructor(public firebaseQuote: any) {}
}


export class ActionReBuildCartItems implements Action {
  readonly type = "ACTION_REBUILD_CART_ITEMS";
  constructor() {}
}

/**when combo order exist in cartproducts
 * dispatch this action 
 */
export class ActionCreateInstantSyncOrder implements Action {
  readonly type = "ACTION_CREATE_INSTANT_SYNC_ORDER";
  constructor(public firebaseQuote: any) {}
}

export class ActionPostQuoteToFireBase implements Action {
  readonly type = " ACTION_POST_QUOTE_TO_Firebase";
  constructor(public firebaseQuote: any) {}
}
export class ActionWriteSuccessful implements Action {
  readonly type = "ACTION_WRITE_SUCESSFUL";
  constructor() {}
}

/**when reload the page ,
 * if cart is not empty
 * set the local storage 
 * quote into cart  */
export class ActionSetQuoteToCart implements Action {
  readonly type = "ACTION_SET_QUOTE_TO_CART";
  constructor(public quote: PosQuote) {}
}

export class ActionInstantSyncFailed implements Action {
  readonly type = "ACTION_INSTANT_SYNC_FAILED";
  constructor() {}
}

export class ActionUploadPinelabsBill implements Action {
  readonly type = "ACTION_UPLOAD_PIPNELABS_BILL";
  constructor(
    public payload: {
      transactionData: PlutosRequest
    },
    public quote: PosQuote
  ) {}
}

export class ActionUploadPinelabsBillDone implements Action {
  readonly type = "ACTION_UPLOAD_PIPNELABS_BILL_DONE";
  constructor(
    public plutusTransactionReferenceID: number
  ) {}
}

export class ActionUploadPinelabsBillFailed implements Action {
  readonly type = "ACTION_UPLOAD_PIPNELABS_BILL_FAILED";
  constructor(
  ) {}
}

export class ActionCancelPlutosTransaction implements Action {
  readonly type = "ACTION_PLUTOS_CANCEL_TRANSACTION";
  constructor(
    public payload: {
      transactionData: PlutosRequest
    }
  ) {}
}

export class ActionPlutosTransactionCancelled implements Action {
  readonly type = "ACTION_PLUTOS_TRANSACTION_CANCELLED";
  constructor() {}
}

export class ActionCancelPlutosTransactionFailed implements Action {
  readonly type = "ACTION_PLUTOS_CANCEL_TRANSACTION_FAILED";
  constructor() {}
}

export class ActionCheckPlutosTransactionStatus implements Action {
  readonly type = "ACTION_CHECK_PLUTOS_TRANSACTION_STATUS";
  constructor(
    public payload: {
      transactionData: PlutosRequest
    }
  ) {}
}

export class ActionPlutosTransactionStatusChecked implements Action {
  readonly type = "ACTION_PLUTOS_TRANSACTION_STATUS_CHECKED";
  constructor(
    public isPlutusTransactionApproved: boolean
  ) {}
}


export class ActionPlutosTransactionStatusFailed implements Action {
  readonly type = "ACTION_PLUTOS_TRANSACTION_STATUS_FAILED";
  constructor(
    public isPlutusTransactionApproved: boolean
  ) {}
}


export class ActionUpdatePlutosReferenceId implements Action {
  readonly type = "ACTION_UPDATE_PLUTOS_REFERENCE_ID";
  constructor(public plutusTransactionReferenceID: number) {}
}
